<template>
  <div :style="{'width': resultControlWidth}" class="text-input-with-controls">
    <v-text-field
      ref="input"
      v-bind="$attrs"
      v-model="draftComputed"
      :append-outer-icon="outerIcon"
      :append-icon="editMode && hasChanges &&!loading && canEdit? 'fas fa-check' : undefined"
      :readonly="!editMode || !canEdit"
      :append-outer-icon-cb="switchMode"
      :append-icon-cb="handleSaveButtonClick"
      :loading="loading"
      :disabled="!!loading"
      :error-messages="manualErrorMessages"
      @input="throttledHandleChange"
    />
  </div>
</template>
<script>
import _ from 'lodash'

const DEFAULT_CONTROL_WIDTH = '100%'

export default {
  name: 'text-input-with-controls',
  props: {
    value: {},
    outputFormatters: {
      type: Array
    },
    controlWidth: {
      type: String
    },
    context: {},
    saveHandler: {
      type: Function
    },
    canEdit: {
      type: Boolean
    }
  },
  data () {
    return {
      manualErrorMessages: [],
      resultControlWidth: this.controlWidth || DEFAULT_CONTROL_WIDTH,
      draft: this.value,
      editMode: false,
      hasChanges: false,
      loading: false
    }
  },
  computed: {
    draftComputed: {
      get: function () {
        if (this.editMode) {
          return this.draft
        }

        let f = _.flow(this.outputFormatters || [])
        return f(this.draft)
      },
      set: function (newValue) {
        this.draft = newValue
      }
    },
    outerIcon () {
      if (!this.canEdit) {
        return undefined
      }

      return this.editMode ? 'fas fa-times' : 'fas fa-pencil-alt'
    }
  },
  methods: {
    switchMode () {
      if (this.loading) {
        return
      }

      this.editMode = !this.editMode
      if (this.editMode) {
        this.$refs['input'].focus()
      } else {
        this.reset()
      }
    },
    reset () {
      if (this.draft !== this.value) {
        this.draft = this.value
      }

      this.hasChanges = false
      this.manualErrorMessages = []
    },
    async handleSaveButtonClick () {
      this.loading = 'primary'

      let errors = await this.saveHandler({
        value: this.draft,
        context: this.context
      })

      this.loading = false

      if (errors != null) {
        this.manualErrorMessages = errors
        return
      }

      this.switchMode()
    },
    throttledHandleChange: _.throttle(function () {
      this.hasChanges = this.draft !== this.value
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Ui/TextInputWithControls.vue